<!--- question-card horizontal-->
<ng-container *ngIf="type === 'horizontal'">
	<div class="fx-column fx-start-stretch">
		<ng-container *ngIf="cardData?.forwarderName || ![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center fx-grow fx-shrink">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
					<img (click)="forwarderUserInfo(cardData)" [src]="cardData?.forwarderThumbnail"
						(error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="cardData?.forwarderName">
					<span class="sub-caption-1" (click)="forwarderUserInfo(cardData)">{{cardData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="question-card fx-row fx-space-between-stretch">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
			<ng-container *ngIf="cardData?.thumbnail">
				<div class="fx-row fx-start-start">
					<div class="thumbnail-block">
						<div class="thumbnail">
							<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'man')"
								(click)="profileInfo(cardData)">
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container  *ngIf="[null,undefined, ''].includes(cardData?.thumbnail)">
				<div class="fx-row fx-start-start">
					<div class="thumbnail-block">
						<div class="thumbnail">
							<img src="assets/img/man.png" (click)="profileInfo(cardData)">
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="cardData?.type || cardData?.status || cardData?.userThumbnail || cardData?.actions?.length || cardData?.title || cardData?.description || cardData?.creator || cardData?.date || cardData?.courseDuration || ![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount)">
				<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
					<div class="patch-block fx-row fx-space-between-center">
						<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="data">
						</ng-container>
					</div>
					<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
						<div class="title-blk fx-column fx-grow fx-shrink">
							<ng-container *ngIf="cardData?.title" [ngTemplateOutlet]="title" [ngTemplateOutletContext]="data">
							</ng-container>
						</div>
						<div class="fx-row-wrap fx-space-between-center">
							<ng-container
								*ngIf="cardData?.date || cardData?.actions?.length || cardData?.commentsCount || cardData?.title">
								<div class="fx-row fx-start-center">
									<ng-container *ngIf="cardData?.creator">
										<div class="contributor fx-row fx-start-center">
											<span class="cursor-pointer" (click)="profileInfo(cardData)">{{cardData?.creator}}</span>
											<ng-container *ngIf="![null,undefined].includes(cardData?.usersCount)">
												<span class="sub-caption-2 cursor-pointer" (click)="usersInfo()">+
													{{cardData?.usersCount}}</span>
											</ng-container>
										</div>
									</ng-container>
									<ng-container *ngIf="cardData?.date">
										<div class="date fx-row fx-start-center" fxLayoutGap="5px">
											<span>{{cardData?.date}}</span>
										</div>
									</ng-container>
									<ng-container *ngIf="cardData?.actions?.length">
										<ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="data">
										</ng-container>
									</ng-container>
								</div>
							</ng-container>
							<ng-container *ngIf="cardData?.commentsCount || ![null, undefined].includes(cardData?.rating)">
								<div class="fx-row fx-start-center">

									<ng-container *ngIf="![null, undefined].includes(cardData?.rating)">
										<div class="rating">
											<ng-container *ngFor="let rate of cardData?.ratingData">
												<ng-container *ngIf="rate?.isInt && rate?.value !== 0">
													<mat-icon>star</mat-icon>
												</ng-container>
												<ng-container *ngIf="rate?.isFloat && rate?.value !== 0">
													<mat-icon>star_half</mat-icon>
												</ng-container>
												<ng-container *ngIf="rate?.value === 0">
													<mat-icon>star_border</mat-icon>
												</ng-container>
											</ng-container>
										</div>
									</ng-container>

									<div class="answer-count fx-row fx-start-center">
										<span>{{(cardData?.commentsCount | abbreviateNumber) || 0}} {{locale.translate('answers')}}</span>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			</div>
			<div *ngIf="cardData?.removable" class="cancel" fxLayoutAlign="start start">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>


<!---vertical---->
<ng-container *ngIf="type === 'vertical'">
	<div class="question-card vertical fx-column fx-start-stretch">
		<ng-container *ngIf="cardData?.forwarderName || ![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
					<img [src]="cardData?.forwarderThumbnail" (error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="cardData?.forwarderName">
					<span class="sub-caption-1">{{cardData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="fx-column fx-start-stretch fx-grow fx-shrink">
			<div class="patch-block fx-start-start">
				<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="data">
				</ng-container>
			</div>
			<ng-container *ngIf="cardData?.thumbnail">
				<div class="fx-row fx-center-center">
					<div class="thumbnail-block">
						<div class="thumbnail">
							<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')"
								(click)="profileInfo(cardData)">
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="cardData?.type || cardData?.status || cardData?.userThumbnail || cardData?.actions?.length || cardData?.title || cardData?.description || cardData?.creator || cardData?.date || cardData?.courseDuration || ![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount)">
				<div class="content-block  fx-column fx-space-between-stretch fx-grow fx-shrink">
					<ng-container
						*ngIf="cardData?.date || cardData?.actions?.length || cardData?.commentsCount || cardData?.title">
						<div class="contributor-block fx-row"
							[ngClass]="(((cardData?.creator || ![null, undefined].includes(cardData?.userThumbnail)) && cardData?.courseDuration) || ((cardData?.creator || ![null, undefined].includes(cardData?.userThumbnail)) && cardData?.date) || (cardData?.creator && cardData?.date)) ? 'fx-space-between-center' : 'fx-end-center'">
							<ng-container *ngIf="cardData?.creator">
								<div class="contributor fx-row fx-start-center">
									<span class="cursor-pointer" (click)="profileInfo(cardData)">{{cardData?.creator}}</span>
									<ng-container *ngIf="![null,undefined].includes(cardData?.usersCount)">
										<span class="sub-caption-2 cursor-pointer" (click)="usersInfo()">+ {{cardData?.usersCount}}</span>
									</ng-container>
								</div>
							</ng-container>
							<ng-container *ngIf="cardData?.date">
								<div class="date fx-row fx-start-center" fxLayoutGap="5px">
									<span>{{cardData?.date}}</span>
								</div>
							</ng-container>
						</div>
					</ng-container>
					<ng-container
						*ngIf="cardData?.date || cardData?.actions?.length || cardData?.commentsCount || cardData?.title">
						<div class="overview-block fx-column fx-space-between-stretch  fx-grow fx-shrink">
							<div class="fx-column fx-start-stretch fx-grow fx-shrink">
								<div class="title-blk fx-row fx-start-center">
									<ng-container *ngIf="cardData?.title" [ngTemplateOutlet]="title" [ngTemplateOutletContext]="data">
									</ng-container>
								</div>
								<ng-container *ngIf="cardData?.actions?.length">
									<div class="fx-row fx-center-center">
										<ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="data">
										</ng-container>
									</div>
								</ng-container>
							</div>
							<div class="fx-column fx-start-stretch">
								<ng-container *ngIf="cardData?.commentsCount || ![null, undefined].includes(cardData?.rating)">
									<div class="fx-row"
										[ngClass]="((![null, undefined].includes(cardData?.rating) && ![null, undefined].includes(cardData?.commentsCount))) ? 'fx-space-between-center' : 'fx-end-center'">
										<ng-container *ngIf="![null, undefined].includes(cardData?.rating)">
											<div class="rating">
												<ng-container *ngFor="let rate of cardData?.ratingData">
													<ng-container *ngIf="rate?.isInt && rate?.value !== 0">
														<mat-icon>star</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate?.isFloat && rate?.value !== 0">
														<mat-icon>star_half</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate?.value === 0">
														<mat-icon>star_border</mat-icon>
													</ng-container>
												</ng-container>
											</div>
										</ng-container>
										<div class="answer-count fx-row fx-start-center">
											<span>{{(cardData?.commentsCount | abbreviateNumber) || 0}} {{locale.translate('answers')}}</span>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</ng-container>

				</div>
			</ng-container>
			<div *ngIf="cardData?.removable" class="cancel fx-center-center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>
<!----end-->

<!--- question-card horizontal-->
<ng-container *ngIf="type === 'minimal'">
	<div class="question-card minimal fx-column fx-start-stretch">
		<div class="fx-row fx-start-stretch fx-grow fx-shrink">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="cardData?.thumbnail">
					<div class="fx-row fx-start-start">
						<div class="thumbnail-block">
							<div class="thumbnail">
								<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')"
									(click)="profileInfo(cardData)">
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="cardData?.type || cardData?.title">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<div class="patch-block">
							<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="data">
							</ng-container>
						</div>
						<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
							<div class="title-blk fx-column fx-grow fx-shrink">
								<ng-container *ngIf="cardData?.title" [ngTemplateOutlet]="title" [ngTemplateOutletContext]="data">
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="cardData?.removable" class="cancel" fxLayoutAlign="center center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #title>
	<div fxLayoutAlign="start center">
		<p class="card-title linkable" (click)="info(data)">{{data?.title}}</p>
	</div>
</ng-template>

<ng-template #typePatch>
	<div class="content-type" fxLayoutAlign="start start">
		<div class="patch sub-txt-patch">{{ locale.translate('answer') }}</div>
	</div>
</ng-template>

<ng-template #statusPatch>
	<p class="sub-txt-patch warn">{{ locale.translate('public') }}</p>
</ng-template>

<ng-template #actions>
	<div class="button-block" fxLayout="row" [fxLayoutAlign]="type === 'horizontal' ? 'start center' : 'center center'">
		<ng-container *ngFor="let action of cardData?.actions">
			<button mat-button class="prime-mini-btn" type="button" [ngClass]="action?.classes" #actionEl
				(click)="actionInfo({actionEl: actionEl, action: action})">
				{{action?.caption}}
			</button>
		</ng-container>
	</div>
</ng-template>
